module.exports = "<app-card [disabled]=\"disabled\" [cardsList]=\"paginaCards\" (eventoPegarCard)=\"direcionar($event)\"></app-card>\n\n<app-botao-flutuante-voltar [param]=\"param\"></app-botao-flutuante-voltar>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/card-menu/card-menu-administrativo/card-menu-administrativo.component.html
// module id = ../../../../../src/app/area-restrita/card-menu/card-menu-administrativo/card-menu-administrativo.component.html
// module chunks = main